import React from 'react';

export default function Settings() {
  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="mt-2 text-sm text-gray-600">
          Platform settings and configuration.
        </p>
      </div>

      <div className="card p-6">
        <p className="text-sm text-gray-600">
          Settings configuration will be available in a future update.
        </p>
      </div>
    </div>
  );
}